var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.token)?_c('Login'):_vm._e(),(_vm.token)?_c('ShuifaData'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }